<template>
  <div class="container lg:w-3/5 xl:w-5/12 flex flex-col justify-center items-center">
    <header class="h3 text-center pb-8">
      {{ headerTxt }}
    </header>

    <select-box v-if="filterOptions && filterOptions.length" v-model="selected" :options="filterOptions" return-object label="Soort activiteit" class="pb-6"/>

    <ul class="w-full">
      <li v-for="item in items" :key="item.slug">
        <nuxt-link :to="{name: 'begeleiders-netwerkactiviteiten-slug', params: {slug: item.slug}}" class="w-full flex justify-between p-4 mb-2 bg-primary-lighter hover:bg-primary-light transition duration-300">
          <div class="flex-1 md:flex-none">
            <time :datetime="item.datum" class="font-bold">{{ item.datum ? $moment(item.datum).format('LL') : 'Doorlopend' }}</time>
            <div class="title">{{ item.title }}</div>
            <div v-if="item.organisatoren" class="subtitle mt-2 text-xs text-secondary">Door: {{ item.organisatoren }}</span></div>
          </div>
          <div v-if="item.locatie" class="flex-1 md:flex-none md:flex-shrink text-right text-secondary-lighter text-sm">
            <font-awesome-icon :icon="['fas', 'map-marker-alt']"/>
            <span class="ml-1">{{ item.locatie }}</span>
          </div>
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
import SelectBox from '~/components/forms/SelectBox';

export default {
  components: {SelectBox},
  props: {
    headerTxt: {
      type: String,
      default: 'Header',
    },
    filterOptions: {
      type: Array,
      default: () => ([]),
    },
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    selected: null,
  }),
  watch: {
    selected: {
      deep: true,
      handler() {
        this.$emit('category-selected', this.selected ? this.selected.slug : null);
      },
    },
  },
};
</script>
